import './index.scss';

// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/rc-tooltip` if it exists o... Remove this comment to see the full error message
import RcTooltip from 'rc-tooltip';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Tooltip = _ref => {
  let {
    children,
    content,
    placement = 'right'
  } = _ref;
  return ___EmotionJSX(RcTooltip, {
    destroyTooltipOnHide: true,
    overlay: content,
    overlayClassName: "le-shared-tooltip",
    placement: placement,
    trigger: ['hover']
  }, children);
};
export default Tooltip;